import { SVGComponentProps } from "@/types/common";
import React from "react";

const UploadIcon = (props: SVGComponentProps) => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.45 32H7.5C6.70435 32 5.94129 31.6839 5.37868 31.1213C4.81607 30.5587 4.5 29.7956 4.5 29V8C4.5 7.20435 4.81607 6.44129 5.37868 5.87868C5.94129 5.31607 6.70435 5 7.5 5H28.5C29.2956 5 30.0587 5.31607 30.6213 5.87868C31.1839 6.44129 31.5 7.20435 31.5 8V23L26.85 18.35C26.2855 17.7968 25.5255 17.4886 24.7352 17.4926C23.9448 17.4965 23.1879 17.8122 22.629 18.371L9 32"
        stroke={props.color || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 29.75L25.5 25.25L30 29.75"
        stroke={props.color || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 33.5V25.25"
        stroke={props.color || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 17C15.1569 17 16.5 15.6569 16.5 14C16.5 12.3431 15.1569 11 13.5 11C11.8431 11 10.5 12.3431 10.5 14C10.5 15.6569 11.8431 17 13.5 17Z"
        stroke={props.color || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
